<template>
  <v-data-table
    :headers="header"
    :items="itens"
    :fixed-header="true"
    :search="search"
    :items-per-page="50"
    :sort-by="['data_solicitacao', 'id']"
    :sort-desc="[false, false]"
    item-key="id"
    show-expand
    class="table-wkf-resposivo-autorizacao"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Solicitações</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisa"
          dense
          outlined
          single-line
          hide-details
          clearable
          v-lazy-input:debounce="400"
          class="pr-4 pl-4 search"
        ></v-text-field>
        <v-menu>
          <template v-slot:activator="{ on: menu, attrs }">
            <v-btn
              color="white"
              v-bind="attrs"
              v-on="{ ...menu }"
              height="39px"
            >
              <v-icon color="grey" left>mdi-filter</v-icon>
              {{ tipo.title }}
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in tipos"
              :key="index"
              @click="menuItem(item)"
            >
              <v-list-item-title>{{ item.label }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-dialog persistent v-model="dialog" max-width="600px">
          <v-card style="border: 1px solid #fff">
            <v-toolbar dark flat color="#042333" height="50px">
              <v-btn icon dark @click="close">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title class="subtitle-1">
                {{ title }}
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pb-0">
              <v-container fill-height fluid>
                <v-row align="center" justify="center" style="min-height: 55vh">
                  <v-col class="pb-0">
                    <v-select
                      v-model="form.status_auto"
                      :items="selects.status_auto"
                      label="Status"
                      class="mt-10"
                      outlined
                      :error-messages="errorStatus"
                      @input="$v.form.status_auto.$touch()"
                      @blur="$v.form.status_auto.$touch()"
                      autofocus
                    ></v-select>
                    <v-textarea
                      outlined
                      v-model="form.observacao"
                      label="Observações"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="white" @click="close"> Cancelar </v-btn>
              <v-btn color="#042333" dark @click="salvar">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
      <v-btn
        icon
        title="Editar Item"
        @click="editar(item)"
        v-if="
          (item.data_solicitacao || isExpanded == true) &&
          item.status_auto != 'R'
        "
      >
        <div v-if="isExpanded == true" class="btn-autorizar-all">
          <v-icon>mdi-key</v-icon>
          <span class="btn-text">TODOS</span>
        </div>
        <div v-else>
          <v-icon>mdi-key</v-icon>
        </div>
      </v-btn>
      <v-btn @click="expand(!isExpanded)" v-if="!item.data_solicitacao" icon>
        <v-icon>
          {{ isExpanded == false ? "mdi-chevron-down" : "mdi-chevron-up" }}
        </v-icon>
      </v-btn>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="pa-0">
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <tr
                v-for="(i, k) in item.items"
                :key="k"
                style="background-color: #f0f0f06e"
              >
                <td class="text-center" style="width: 1px; min-width: 1px"></td>
                <td class="text-center" style="width: 77px; min-width: 77px">
                  {{ i.id }}
                </td>
                <td class="text-center" style="width: 138px; min-width: 138px">
                  {{ i.data_solicitacao }}
                </td>
                <td style="width: 12%; min-width: 12%">
                  {{ i.solicitante }}
                </td>
                <td v-html="i.item_referencia"></td>
                <td style="width: 18%; min-width: 18%">{{ i.item }}</td>
                <td style="width: 100px; min-width: 100px">
                  <div
                    v-if="i.status_auto == 'A'"
                    class="green--text text--darken-4"
                  >
                    Autorizado
                  </div>
                  <div v-if="i.status_auto == 'R'" class="red--text">
                    Reprovado
                  </div>
                </td>
                <td class="text-center" style="width: 50px; min-width: 50px">
                  <v-btn
                    icon
                    title="Editar Item"
                    class="mr-2"
                    @click="editar(i)"
                  >
                    <v-icon>mdi-key</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </td>
    </template>
    <template v-slot:item.id="{ item }">
      <template v-if="item.data_solicitacao">{{ item.id }}</template>
      <template v-else>Pedido: {{ item.id }}</template>
    </template>
    <template v-slot:item.data_solicitacao="{ item }">
      <template v-if="item.data_solicitacao">
        {{ item.data_solicitacao }}
      </template>
      <div v-else>---</div>
    </template>
    <template v-slot:item.solicitante="{ item }">
      <template v-if="item.solicitante">
        {{ item.solicitante }}
      </template>
      <div v-else class="ml-7">---</div>
    </template>
    <template v-slot:item.item="{ item }">
      <template v-if="item.item">
        {{ item.item }}
      </template>
      <div v-else class="ml-7">---</div>
    </template>
    <template v-slot:item.item_referencia="{ item }">
      <div v-html="item.item_referencia" v-if="item.item_referencia"></div>
      <div v-else class="ml-7">---</div>
    </template>
    <template v-slot:item.status_auto="{ item }">
      <div v-if="item.status_auto == 'A'" class="green--text text--darken-4">
        Autorizado
      </div>
      <div v-else-if="item.status_auto == 'R'" class="red--text">Reprovado</div>
      <div v-else class="ml-7">---</div>
    </template>
  </v-data-table>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      header: [
        { text: "#", value: "id", width: "97px", align: "center" },
        {
          text: "Data Solicitação",
          value: "data_solicitacao",
          width: "138px",
          align: "center",
        },
        { text: "Solicitante", value: "solicitante", width: "12%" },
        { text: "Item de referência", value: "item_referencia" },
        { text: "Solicitação", value: "item", width: "18%" },
        { text: "Status", value: "status_auto", width: "100px" },
        {
          text: "",
          value: "data-table-expand",
          width: "100px",
          align: "center",
        },
      ],
      search: "",
      dialog: false,
      title: "",
      form: {
        id: "",
        observacao: "",
        status_auto: [],
      },
      selects: {
        status_auto: [
          { value: "A", text: "Autorizado" },
          { value: "R", text: "Reprovado" },
        ],
      },
    };
  },
  validations: {
    form: {
      status_auto: { required },
    },
  },
  computed: {
    ...mapGetters("wkfAutorizacao", ["itens", "tipos", "tipo"]),
    errorStatus() {
      const errors = [];
      if (!this.$v.form.status_auto.$dirty) return errors;
      !this.$v.form.status_auto.required &&
        errors.push("O status é obrigatório.");
      return errors;
    },
  },
  mounted() {
    this.$store.dispatch("wkfAutorizacao/Itens", {});
  },
  methods: {
    ...mapMutations("app", ["setDialogAutorizacao"]),
    editar(prop) {
      this.dialog = true;
      this.form.id = prop.id;
      if (prop.items) {
        this.form.ids = [...prop.items.map((p) => p.id)];
      }
      this.form.status_auto = prop.status_auto;
      this.form.observacao = prop.observacao;
      let descricao = prop.item_referencia_descricao
        ? prop.item_referencia_descricao + " - "
        : "";
      let item = prop.item ? prop.item : "Autorização de Pedido: " + prop.id;
      this.title = descricao + item;
      this.$v.$reset();
    },
    salvar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.form.id) {
          this.$store.dispatch("wkfAutorizacao/Update", this.form).then(() => {
            this.$store.dispatch("notificacao/Itens");
            this.close();
          });
        }
      }
    },
    close() {
      this.form = { id: "", observacao: "", status_auto: [] };
      this.dialog = false;
      this.$v.$reset();
    },
    menuItem(prop) {
      this.$store.dispatch("wkfAutorizacao/Itens", { tipo: prop });
    },
  },
  watch: {},
};
</script>
<style>
.autorizacao-top-bar .table-wkf-resposivo-autorizacao > .v-data-table__wrapper {
  height: calc(100vh - 171px) !important;
}
.table-wkf-resposivo-autorizacao > .v-data-table__wrapper {
  height: calc(100vh - 260px) !important;
}
.btn-autorizar-all {
  margin-top: -10px;
}
.btn-autorizar-all .btn-text {
  position: absolute;
  font-size: 10px;
  margin-top: 17px;
  font-weight: 800;
  letter-spacing: -0.6px;
  margin-left: -28px;
}
</style>
